<section class="page-heading">
  <h1>Review your Payment</h1>
  <h2 class="page-sub-header">Please review the details before confirming the transaction.</h2>
</section>

<terra-loader *ngIf="isLoading$ | async else content" class="loader" />

<ng-template #content>
  <section>
    <h3 class="section-title">
      <span>Overview</span>
      <a class="link" [routerLink]="editPaymentPage$ | async">Edit details</a>
    </h3>

    <div class="wrapper">
      <!--  Left side  -->
      <div class="payment-details">
        <terra-unit-payment-details [payment]="payment$ | async" [sourceBankAccount]="sourceBankAccount$ | async" />
      </div>
      <!-- Right side -->
      <div class="sender-and-recipient-details">
        <!--  Sender card -->
        <mat-card>
          <terra-unit-payment-sender-details [payment]="payment$ | async" [sourceBankAccount]="sourceBankAccount$ | async" />
        </mat-card>

        <!--  Recipient card -->
        <mat-card>
          <terra-unit-payment-recipient-details [payment]="payment$ | async" [sourceBankAccount]="sourceBankAccount$ | async" [isGp]="isGp" />
        </mat-card>
      </div>
    </div>
  </section>

  <hr class="separator"/>

  <div class="fees">
    <terra-unit-payment-overview-key-value-pair key="Total Transaction Fees" [value]="(payment$ | async)?.fee" unit="$" />
  </div>

  <div class="notes">
    <ng-container *ngIf="isWirePayment$ | async">
      <span class="accept-transaction-fee">
        <mat-checkbox color="primary" class="regular-checkbox" [(ngModel)]="acceptTransactionFee" [checked]="acceptTransactionFee">
          I understand and agree to the fees associated with this transaction.
        </mat-checkbox>
      </span>
    </ng-container>
    
    <span class="title">Please note:</span>
    <span>- You can always track the status of the transaction on the
      <a class="link" target="_blank" [href]="bankAccountPage$ | async">bank account page</a>.
    </span>
    <span class="terms-and-conditions">
      <span>Check these to indicate that you have read and agree to the following:</span>
      <mat-checkbox color="primary" class="regular-checkbox" (change)="agreedToTerms$.next($event.checked)" [checked]="agreedToTerms$ | async">
        <a class="link" target="_blank" href="{{termType.getUrl(termType.ClientTermsOfService)}}">Terms of Service</a>
      </mat-checkbox>
    </span>

    <div class="terra-error-style">
      <mat-error *ngIf="bankAccountBalanceErrorMessage$ | async">
        {{bankAccountBalanceErrorMessage$ | async}}
      </mat-error>
      <mat-error *ngIf="generalError$ | async">
        An error has occurred. Please try again, and if no luck, please contact support.
      </mat-error>
      <mat-error *ngIf="serverErrorMessage$ | async">
        {{serverErrorMessage$ | async}}
      </mat-error>
    </div>

    <span class="buttons">
      <button mat-flat-button type="button" color="primary" class="confirm-button"
              [disabled]="!(agreedToTerms$ | async) || 
              (!acceptTransactionFee && (isWirePayment$ | async))
              || (bankAccountBalanceErrorMessage$ | async).length > 0" (click)="verifyPhone()">
        Confirm & Execute Payment
      </button>

      <button mat-stroked-button type="button" (click)="goBack()">
        Back
      </button>
    </span>
  </div>
</ng-template>
